import { GET_BROADCAST_MESSAGES, UPDATE_BROADCAST_MESSAGES } from './../constants/actionTypes'

const broadcastMessages = (store = [], action = []) => {
  switch (action.type) {
    case GET_BROADCAST_MESSAGES:
      return action.data
    case UPDATE_BROADCAST_MESSAGES:
      return action.data
    default:
      return store
  }
}

export { broadcastMessages }
